export const MEMBERSHIP = 'MEMBERSHIP';
export const SUPPORT = 'SUPPORT';
export const COMMISSION = 'COMMISSION';

export const MEMBERSHIP_NAMES = {
  [MEMBERSHIP]: 'studio::menus::membership_adjustment',
  [SUPPORT]: 'studio::menus::support_adjustment',
  [COMMISSION]: 'studio::menus::commission_adjustment',
};

export const MEMBERSHIP_GUIDE_PDF =
  'https://s3.marpple.co/marpple_shop/guidebook/MarppleShop_Creator_Membership_Guide.pdf';
export const MEMBERSHIP_OVERVIEW_PDF =
  'https://s3.marpple.co/marpple_shop/guidebook/MarppleShop_Creator_Membership.pdf';
export const MEMBERSHIP_STARTER_APPLY_FORM =
  'https://docs.google.com/forms/d/e/1FAIpQLSdoR8lF43ozv7ko6AADb8qEKmWapsCHxE1EUkJmi7BQuQ5DHA/viewform';

export const MEMBERSHIP_UI_IDENTIFIER = 'membership-ui-identifier';
export const MEMBERSHIP_SDK_GLOABL_STYLE_IDENTIFIER = 'membership-sdk-global-style-identifier';

export * from './error';
export * from './path';
export * from './fields';
export * from './commission';
